<template>
  <div class="pre-new-stu">
    <color-list
      :title="$t('app.roomType')"
      :color-list="colorList"
    ></color-list>
    <color-list
      :title="$t('app.roomStatus')"
      :color-list="colorListSecond"
    ></color-list>
    <color-list
      :title="$t('app.studentType')"
      :color-list="colorListThird"
    ></color-list>
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-checkbox
      v-model="search.special"
      size="small"
      style="margin-right: 10px"
    >
      {{ $t("app.specialRequirement") }}
    </el-checkbox>
    <el-button type="primary" size="small" @click="reset" :disabled="isStart">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      icon="el-icon-search"
      size="small"
      @click="getList"
      :disabled="isStart"
      >{{ $t("app.search") }}</el-button
    >
    <download-excel
      type="button"
      class="el-button el-button--success el-button--small"
      :data="tableData"
      header="新生預分配表"
      name="新生預分配表.xls"
      :fields="exportColumns"
      :footer="this.generateExportCondition()"
      >導出</download-excel
    >
    <br />
    <el-button
      type="primary"
      size="small"
      style="margin-top: 10px"
      @click="startPreAlloc"
      :loading="isStart"
      >{{ $t("app.startPreAlloc") }}</el-button
    >
    <el-button
      type="primary"
      size="small"
      style="margin-top: 10px"
      @click="batchConfirmation"
      v-show="multipleSelection.length > 0"
      >{{ $t("app.batchConfirmation") }}</el-button
    >
    <el-button
      type="warning"
      size="small"
      style="margin-top: 10px"
      @click="batchDebit"
      v-show="showBatchDebit()"
      >{{ $t("app.batchDebit") }}</el-button
    >
    <div class="table-container">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        :data="tableData"
        :cell-style="cellStyle"
        style="width: 100%"
        height="500"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          align="left"
          width="360px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.haveFee"
              size="small"
              type="primary"
              @click="confirmItem(scope.row)"
              :disabled="isStart"
              >{{ $t("app.confirmS") }}</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="refuse(scope.row)"
              :disabled="isStart"
              >{{ $t("app.refuse") }}</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="adjust(scope.row)"
              :disabled="isStart"
              >{{ $t("app.adjustment") }}</el-button
            >
            <el-button
              size="small"
              type="success"
              @click="viewDetails(scope.row)"
              :disabled="isStart"
              >{{ $t("app.viewDetails") }}</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="debit(scope.row)"
              :disabled="isDebit(scope.row)"
              >{{ $t("app.debit") }}</el-button
            >
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'applicationNumber' ||
                col.model === 'native' ||
                col.model === 'programme'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            width="120px"
          >
            <template slot-scope="scope">
              <template
                v-if="col.model === 'nameEnglish' || col.model === 'status'"
              >
                <div style="word-break: normal">
                  {{ scope.row[col.model] }}
                </div>
              </template>
              <template v-else>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
      :disabled="isStart"
    >
    </el-pagination>
    <adjust-modal ref="adjustModal" @adjustSuccess="getList"></adjust-modal>
    <details-modal ref="detailsModal"></details-modal>
    <debit-modal ref="debitModal" @debitSuccess="getList"></debit-modal>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import AdjustModal from "./modules/NewStuAdjustModal";
import DetailsModal from "./modules/DetailsModalNew";
import ColorList from "@/components/tools/ColorList";
import DebitModal from "./modules/DebitConfirmModal";
import {
  getRoomColor,
  getBedColor,
  getPersonColor
} from "@/api/dormitoryManagement/list";
import {
  getList,
  confirm,
  startPreallocate,
  batchConfirm,
  refuse
} from "@/api/dormitoryManagement/preAllocNewStu";
export default {
  components: {
    AdjustModal,
    DetailsModal,
    ColorList,
    DebitModal,
    DownloadExcel: JsonExcel
  },
  data() {
    return {
      searchInput: [
        { model: "roomCode", label: this.$t("app.roomCode") },
        { model: "applyCode", label: this.$t("app.applicationNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "contact", label: this.$t("app.contactInformation") },
        { model: "native", label: this.$t("app.studentNative") },
        { model: "programme", label: this.$t("app.studentProgramme") }
      ],
      column: [
        { model: "room", label: this.$t("app.room") },
        { model: "bed", label: this.$t("app.bed") },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "gender", label: this.$t("app.gender") },
        { model: "applicationNumber", label: this.$t("app.applicationNumber") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation")
        },
        { model: "status", label: this.$t("app.status") },
        {
          model: "specialTypeDetail",
          label: this.$t("app.applyOldView.specialTypeDetail")
        },
        {
          model: "native",
          label: this.$t("app.studentNative")
        },
        {
          model: "localOrNot",
          label: this.$t("app.localOrNot")
        },
        {
          model: "programme",
          label: this.$t("app.studentProgramme")
        },
        {
          //model: "roomTypeRequirement",
          model: "selectedRoomTypeText",
          label: this.$t("app.roomType")
        },
        {
          model: "roomMateRequirement",
          label: this.$t("app.applyView.roommate")
        },
        {
          model: "arrivalDate",
          label: this.$t("app.dateOfArrivalInMacao")
        },
        {
          model: "planArrivalTime",
          label: this.$t("app.timeOfArrivalInMacao")
        },
        {
          model: "meetServiceDisplay",
          label: this.$t("app.applyView.serve")
        },
        {
          model: "meetAddressDisplay",
          label: this.$t("app.portOfArrival")
        },
        {
          model: "filghtNumber",
          label: this.$t("app.applyView.flightNumber")
        },
        {
          model: "requirement",
          label: this.$t("app.applyView.OtherRequirement")
        }
      ],
      colorList: [],
      colorListSecond: [],
      colorListThird: [],
      multipleSelection: [],
      options: [
        {
          value: false,
          label: this.$t("app.noSpecialRequirement")
        },
        {
          value: true,
          label: this.$t("app.haveSpecialRequirement")
        }
      ],
      search: {
        roomCode: "",
        studentNumber: "",
        applyCode: "",
        name: "",
        contact: "",
        native: "",
        programme: "",
        orderKey: "",
        orderType: ""
      },
      isStart: false,
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      exportColumns: {
        英文名: "nameEnglish",
        中文名: "nameChina",
        性別: "gender",
        申請編號: "applicationNumber",
        學生編號: "studentNumber",
        聯繫方式: "contactInformation",
        交費狀態: "status",
        獎學金: "specialTypeDetail",
        籍貫: "native",
        "本地/非本地": "localOrNot",
        學系: "programme",
        // 房間類型: "roomTypeRequirement",
        房間類型: "selectedRoomTypeText",
        室友選擇: "roomMateRequirement",
        抵澳日期: "arrivalDate",
        抵澳時間: "planArrivalTime",
        航班號: "filghtNumber",
        口岸抵步接載服務: "meetServiceDisplay",
        抵步口岸: "meetAddressDisplay",
        備註: "requirement"
      }
    };
  },
  created() {
    this.getList();
    this.getColor();
  },
  computed: {
    selectList() {
      return this.multipleSelection.map(_ => _.applicationNumber);
    }
  },
  methods: {
    returnRoomTypeText(value) {
      let target = this.colorList.find(item => item.code === value);
      return target?.text;
    },
    getColor() {
      getRoomColor().then(res => {
        this.colorList = res.data.map(item => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color
          };
        });
      });
      getBedColor().then(res => {
        this.colorListSecond = res.data.map(item => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color
          };
        });
      });
      getPersonColor().then(res => {
        this.colorListThird = res.data.map(item => {
          return {
            code: item.Code,
            text: item.Text,
            color: item.Color
          };
        });
      });
    },
    getList() {
      getList({
        ContactMobile: this.search.contact,
        RoomIndex: this.search.roomCode,
        Name: this.search.name,
        StudentCode: this.search.studentNumber,
        ApplicationCode: this.search.applyCode,
        Native: this.search.native,
        Programme: this.search.programme,
        PageIndex: this.currentPage,
        PageSize: this.size,
        HaveSpecialRequirement: this.search.special,
        OrderKey: this.search.orderKey,
        OrderType: this.search.orderType
      }).then(res => {
        this.total = res.data.Total;
        let data = res.data.Items || [];
        this.tableData = data.map(item => {
          return {
            applicationNumber: item.ApplicationCode,
            arrivalDate: item.ArrivalDate,
            bed: item.Bed,
            bedState: item.BedState,
            bedColor: item.BedStateColor,
            nameChina: item.ChineseName,
            contactInformation: item.ContactMobile,
            departureDate: item.DepartureDate,
            departurePort: item.DeparturePort,
            departureTime: item.DepartureTime,
            email: item.Email,
            status: item.DebitState,
            firstName: item.FirstName,
            filghtNumber: item.FlightNumber,
            nameEnglish: item.FullName,
            gender: item.Gender,
            lastName: item.LastName,
            meetAddress: item.MeetAddress,
            meetService: item.MeetService,
            mobile: item.Mobile,
            nationCode: item.NationCode,
            originalSchool: item.OriginalSchool,
            requirement: item.OtherRequirement,
            planArrivalTime: item.PlanArrivalTime,
            room: item.RoomIndex,
            roomMateRequirement: item.RoomMateRequirement,
            roomState: item.RoomState,
            roomType: item.RoomType,
            roomColor: item.RoomTypeColor,
            roomTypeRequirement: item.RoomTypeRequirement,
            selectedRoomMateType: item.SelectedRoomMateType,
            selectedRoomType: item.SelectedRoomType,
            studentNumber: item.StudentCode,
            personColor: item.SpecialTypeColor,
            studentSpecialType: item.StudentSpecialType,
            debitNo: item.DebitNo,
            otherName: item.OtherName,
            specialTypeDetail: item.SpecialTypeDetail,
            native: item.StudentNative,
            programme: item.Programme,
            haveFee: item.HaveFee,
            meetServiceDisplay: item.MeetServiceDisplay,
            meetAddressDisplay: item.MeetAddressDisplay,
            localOrNot: item.LocalOrNot,
            selectedRoomTypeText: this.returnRoomTypeText(item.SelectedRoomType)
          };
        });
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    viewDetails(row) {
      this.$refs.detailsModal.edit(row);
    },
    reset() {
      this.search.roomCode = "";
      this.search.studentNumber = "";
      this.search.applyCode = "";
      this.search.name = "";
      this.search.contact = "";
      this.search.programme = "";
      this.search.native = "";
      this.search.special = false;
    },
    adjust(row) {
      this.$refs.adjustModal.edit(row, "new");
    },
    batchConfirmation() {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        batchConfirm({
          ApplicationCodeGroup: this.selectList
        }).then(res => {
          if (res.data == false) {
            this.showResponseMessage(res.message);
          } else {
            this.success();
          }
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirmItem(row) {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        confirm({
          ApplicationCode: row.applicationNumber
        }).then(res => {
          if (res.data == false) {
            this.showResponseMessage(res.message);
          } else {
            this.success();
          }
        });
      });
    },
    refuse(row) {
      this.$confirm(this.$t("app.refuseModification") + "?").then(() => {
        refuse({
          ApplicationCode: row.applicationNumber
        }).then(res => {
          if (res.data == false) {
            this.showResponseMessage(res.message);
          } else {
            this.success();
          }
        });
      });
    },
    debit(row) {
      //console.log(row);
      var applicationNumber = row.applicationNumber;
      // 如果没有学生应用ID，就用学生编号代替
      if (applicationNumber === null || applicationNumber === "") {
        applicationNumber = row.studentNumber;
      }
      console.log("需要开票的学生应用ID或编号：" + applicationNumber);
      this.$refs.debitModal.edit(applicationNumber, "1", row.roomType);
    },
    isDebit(row) {
      return row.debitNo === "" || row.debitNo === null ? false : true;
      //return false;
    },
    batchDebit() {
      let debitStudentGroup = [];
      let defaultRoomType;
      let roomType =
        this.multipleSelection.length > 0
          ? this.multipleSelection[0].roomType
          : 0;
      this.multipleSelection.forEach(element => {
        if (element.debitNo === "" || element.debitNo === null) {
          var applicationNumber = element.applicationNumber;
          if (applicationNumber === null || applicationNumber === "") {
            applicationNumber = element.StudentCode;
          }
          debitStudentGroup.push(applicationNumber);
          if (roomType !== element.roomType) {
            defaultRoomType = 2;
          }
        }
      });
      if (defaultRoomType == undefined) {
        defaultRoomType = roomType;
      }
      this.$refs.debitModal.edit(debitStudentGroup, "1", defaultRoomType);
    },
    success() {
      this.$notify({
        title: this.$t("app.success"),
        message: this.$t("app.opeSuccess"),
        type: "success"
      });
      this.getList();
    },
    showResponseMessage(message) {
      this.$notify.info({
        title: this.$t("app.info"),
        message: message,
        duration: 5000
      });
    },
    startPreAlloc() {
      this.isStart = true;
      startPreallocate()
        .then(() => {
          this.$notify({
            title: this.$t("app.success"),
            message: this.$t("app.opeSuccess"),
            type: "success"
          });
          this.isStart = false;
          this.getList();
        })
        .catch(() => {
          this.isStart = false;
        });
    },
    cellStyle(row) {
      let color = "";
      if (row.column.property) {
        if (row.column.property === "room") {
          color = row.row.roomColor;
        } else if (row.column.property === "bed") {
          color = row.row.bedColor;
        } else {
          color = row.row.personColor;
        }
      }
      return {
        background: color
      };
    },
    debitSuccess() {
      this.getList();
    },
    showBatchDebit() {
      let debitStudentGroup = [];
      this.multipleSelection.forEach(element => {
        if (element.debitNo === "" || element.debitNo === null) {
          debitStudentGroup.push(element.studentNumber);
        }
      });
      return debitStudentGroup.length > 0;
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
    generateExportCondition() {
      let condition = "";
      if (this.search.roomCode) {
        condition += "Room is like:" + this.search.roomCode;
      }
      if (this.search.studentNumber) {
        if (condition) {
          condition += ", ";
        }
        condition += "Student ID is like:" + this.search.studentNumber;
      }
      if (this.search.applyCode) {
        if (condition) {
          condition += ", ";
        }
        condition += "Application code is like:" + this.search.applyCode;
      }
      if (this.search.name) {
        if (condition) {
          condition += ", ";
        }
        condition += "Student name is like:" + this.search.name;
      }
      if (this.search.contact) {
        if (condition) {
          condition += ", ";
        }
        condition += "Mobile is like:" + this.search.contact;
      }
      if (this.search.native) {
        if (condition) {
          condition += ", ";
        }
        condition += "Native place:" + this.search.native;
      }
      if (this.search.programme) {
        if (condition) {
          condition += ", ";
        }
        condition += "Programme:" + this.search.programme;
      }
      if (condition) {
        condition += ", ";
      }
      condition += "Export Datetime is:" + new Date();
      return condition;
    }
  }
};
</script>
<style lang="scss" scoped>
.pre-new-stu {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 250px);
    overflow: auto;
  }
}
</style>
